import { CompanyForm } from './components/CompanyForm';
import { Edit, useForm } from '@refinedev/antd';
import { HttpError } from '@refinedev/core';
import { ICompany } from 'interfaces/companies';

export const CompanyEdit = () => {
  const { formProps, saveButtonProps } = useForm<
    ICompany,
    HttpError,
    ICompany
  >();

  return (
    <Edit title="Editar empresa" saveButtonProps={saveButtonProps}>
      <CompanyForm formProps={formProps} />
    </Edit>
  );
};
